import React from 'react';
import Spoiler from '~c/ui/Spoiler';
import { ProfileContext } from '../../dataProvider';
import Loader, { spinnerPositions, spinnerStates } from '~c/ui/Loader';
import { prepareInput, splitInputsByRenderBlock } from '~p/EventReg/Input';
import {
  UserInputsFirst,
  UserInputsSecond,
  UserInputsThird,
} from './UserInputs';
import { passportPatterns, sentUsersBrowserData } from '../../../../EventReg/utils';
import { passportFormatting } from '../../../../../helpers/textFormatting';
import {
  checkNotEmpty,
  checkPassport,
} from '../../../../../helpers/validators';

class User extends React.PureComponent {
  state = {
    inputsFirst: UserInputsFirst,
    inputsSecond: UserInputsSecond,
    inputsThird: UserInputsThird,
    isEditable: false,
    buttonLabel: 'Редактировать',
    spinnerState: spinnerStates.done,
    errorMessage: null,
    isNewsSubscribe: false
  };

  componentDidMount() {
    const pattern = passportPatterns.find(
      mask => mask.citizenshipCode === this.props.user.citizenshipCode,
    );
    const newInputsSecond = this.state.inputsSecond.map(input => {
      if (input.name === 'passport') {
        return {
          ...input,
          mask: pattern?.mask ? pattern.mask : '',
          validator: pattern ? checkPassport : checkNotEmpty,
        };
      }
      return input;
    });

    this.setState({ inputsSecond: newInputsSecond });
  }

  onAvatarInputChange = (event, user) => {
    const newUser = {
      ...user,
      personalPhoto: { SRC: URL.createObjectURL(event.target.files[0]) },
      personalPhotoFile: event.target.files[0],
    };

    const { updateUser } = this.context;
    updateUser(newUser);
  };

  saveUser = async () => {
    const { saveUser } = this.context;

    if (!this.state.isEditable) {
      const lastUser = { ...this.props.user };
      this.setState({
        lastUser,
        buttonLabel: 'Сохранить',
        isEditable: !this.state.isEditable,
      });
    } else {
      this.setState({
        errorMessage: null,
        spinnerState: spinnerStates.pending,
      });
      const errors = await saveUser(this.props.user);
      if (!errors) {
        sentUsersBrowserData({data: this.props.user, isNewsSubscribe: this.state.isNewsSubscribe });
        window.location.reload();
      } else {
        this.setState({
          errorMessage: errors,
          spinnerState: spinnerStates.done,
        });
      }
    }
  };

  renderAvatar = user => {
    const { isEditable } = this.state;
    const { isSelf } = this.props;
    const { clearAvatar } = this.context;

    const renderOverlay = () => {
      return (
        // eslint-disable-next-line
        <div
          className="member__imgOverlay"
          onClick={e => {
            e.stopPropagation();
          }}
        >
          {user.personalPhoto ? (
            <div className="member__buttons">
              <input
                autoComplete="off"
                type="file"
                id="changeAvatar"
                accept="image/png, image/jpeg, image/gif, image/bmp"
                style={{ display: 'none' }}
                onChange={event => this.onAvatarInputChange(event, user)}
              />
              <label
                htmlFor="changeAvatar"
                className="member__button member__editImgBtn"
              />
              <button
                type="button"
                className="member__button member__deleteImgBtn"
                onClick={async () => {
                  const errorMessage = await clearAvatar(user);
                  if (errorMessage) {
                    this.setState({ errorMessage });
                  }
                }}
              />
            </div>
          ) : (
            <div className="member__buttons">
              <input
                autoComplete="off"
                type="file"
                id="uploadAvatar"
                accept="image/png, image/jpeg, image/gif, image/bmp"
                style={{ display: 'none' }}
                onChange={event => this.onAvatarInputChange(event, user)}
              />
              <label
                htmlFor="uploadAvatar"
                className="member__button member__editImgBtn"
              />
            </div>
          )}
        </div>
      );
    };

    if (!user.personalPhoto) {
      return (
        <div className="member__img" data-letter={user?.lastName?.[0] || ''}>
          {isEditable && isSelf && renderOverlay()}
        </div>
      );
    }

    return (
      <div
        className="member__img"
        style={{ backgroundImage: `url(${user.personalPhoto.SRC})` }}
      >
        {isEditable && isSelf && renderOverlay()}
      </div>
    );
  };

  renderUserHeader = (user, isSelf) => {
    return (
      <div className="member member--spoiler">
        {this.renderAvatar(user)}
        <div className="member__inner">
          <p className="member__name">
            {user.lastname !== '' ? `${user.lastName} ` : null}
            {user.name !== '' ? `${user.name?.[0]}.` : null}&nbsp;
            {user.patronymic !== '' ? `${user.patronymic?.[0]}.` : null}
          </p>
          {isSelf ? (
            <ul className="tags tags--yellow tags--sm">
              <li className="tag">Мой профиль</li>
            </ul>
          ) : null}
        </div>
      </div>
    );
  };

  changeInput = (name, value) => {
    const newUser = { ...this.props.user };
    const newState = this.state;

    if (name === 'citizenship') {
      const { citizenshipCode } = newUser;
      if (
        value.citizenship ||
        (value.type === 'onChange' && value.citizenship === '')
      ) {
        const pattern = passportPatterns.find(
          mask => mask.citizenshipCode === value.citizenshipCode,
        );

        newState.inputsSecond = newState.inputsSecond.slice().map(inp => {
          const newInp = Object.assign({}, inp);
          if (newInp.name === 'passport') {
            newInp.mask = pattern?.mask ? pattern.mask : '';
            newInp.validator = pattern ? checkPassport : checkNotEmpty;
            newInp.error = false;
          }
          return newInp;
        });

        newUser.citizenship = value.citizenship;
        newUser.citizenshipCode = value.citizenshipCode;

        if (pattern) newUser.passport = passportFormatting(newUser.passport);
      } else if (!citizenshipCode) {
        newUser.citizenship = '';
        newUser.citizenshipCode = '';
      }
    } else {
      newUser[name] = value;
    }

    this.setState(newState);
    const { updateUser } = this.context;
    updateUser(newUser);
  };

  validateInput = () => {};

  renderInputs = inputs =>
    inputs.map((block, index) => (
      // eslint-disable-next-line
      <div className="inp-wrap" key={index}>
        {block?.map(input =>
          prepareInput({
            ...input,
            disabled: !this.state.isEditable,
            value: this.props.user[input.name],
            onChangeCallback: this.changeInput,
            onBlurCallback: this.validateInput,
          }),
        )}
      </div>
    ));

  renderUserData = user => {
    const {
      isEditable,
      inputsFirst,
      inputsSecond,
      inputsThird,
      buttonLabel,
      errorMessage,
    } = this.state;
    const buttonClass = isEditable
      ? 'btn btn--primary profile__btn'
      : 'btn btn--outline profile__btn';

    const splittedInputsFirst = splitInputsByRenderBlock(inputsFirst);
    const splittedInputsSecond = splitInputsByRenderBlock(inputsSecond);
    const splittedInputsThird = splitInputsByRenderBlock(inputsThird);

    return (
      <div className="registration">
        <h4 className="title member__profile-title">Персональные данные</h4>
        {this.renderInputs(splittedInputsFirst)}
        <div className="separate" />
        {this.renderInputs(splittedInputsSecond)}
        <div className="separate" />
        <h4 className="title member__profile-title">
          Документ о высшем образовании
        </h4>
        {this.renderInputs(splittedInputsThird)}
        <div className="separate" />
        <div className="check registration__policy">
          <label
            className="check__label"
            htmlFor={`subscribeCheckbox_${user.id}`}
          >
            <input
              autoComplete="off"
              disabled={!isEditable}
              className="check__inp"
              type="checkbox"
              name={`subscribeCheckbox_${user.id}`}
              id={`subscribeCheckbox_${user.id}`}
              required=""
              checked={user.subscribe}
              onChange={e => {
                this.changeInput('subscribe', e.target.checked);
                this.setState({
                  isNewsSubscribe: !this.state.isNewsSubscribe
                });
              }}
            />
            <span className="check__box" />
            <p className="check__text">
              Я хочу получать новостные и акционные рассылки Академии
            </p>
          </label>
        </div>
        <button className={buttonClass} type="submit" onClick={this.saveUser}>
          {this.state.spinnerState === spinnerStates.done ? (
            buttonLabel
          ) : (
            <React.Fragment>
              <div className="invisible">Сохранить</div>
              <Loader
                spinnerState={this.state.spinnerState}
                spinnerPosition={spinnerPositions.absolute}
                style={{
                  color: 'white',
                }}
              />
            </React.Fragment>
          )}
        </button>

        {isEditable && (
          <button
            type="button"
            className="btn btn--outline profile__btn"
            onClick={() => {
              const { lastUser } = this.state;
              const { updateUser } = this.context;
              updateUser(lastUser);

              this.setState({
                isEditable: !isEditable,
                buttonLabel: 'Редактировать',
                errorMessage: null,
                spinnerState: spinnerStates.done,
              });
            }}
          >
            Отменить
          </button>
        )}

        {errorMessage && (
          <div className="inp-wrap">
            <div className="error error--red">{errorMessage}</div>
          </div>
        )}
      </div>
    );
  };

  render() {
    const { user, isSelf } = this.props;

    return (
      <Spoiler
        key={`key-${user.id}`}
        header={this.renderUserHeader(user, isSelf)}
        content={this.renderUserData(user)}
        disabled={this.state.isEditable}
      />
    );
  }
}

User.contextType = ProfileContext;

export default User;
